import React from 'react';
import VideoAutoPlay from '../PlayVideo';
import ContainerText from './ContainerText';

import './VideoModules.scss';

export const COMPONENT_NAME = 'Video';

const VideoModules = ({
  align, claim, subClaim, urlVideo, imgDesktop,
}) => {
  return (
    <div className="VideoModules">
      <div className={`VideoModules__container container ${align === 'reverse' ? 'VideoModules__align_reverse' : ''}`}>
        <ContainerText claim={claim} subClaim={subClaim} align={align} />
        <div className="video-wrapper">
          <VideoAutoPlay img height="modulos" width="modulos" urlVideo={urlVideo} playIcon imgDesktop={imgDesktop} />
        </div>
      </div>
    </div>
  );
};

export default VideoModules;
